
import { Avatar, Grid, MenuItem } from '@mui/material';
import { useEffect, useMemo } from 'react';
import Dialog, { IDefaultDialogProps } from '../../Dialog';
import { ActionButton } from '../../Button';
import { useLanguageContext } from '../../../contexts/LanguageContext';
import DefaultConstants from '../../../data/Constants';
import useState from '../../../hooks/useState';
import IServiceOrder from '../../../interfaces/IServiceOrder';
import SelectField from '../../SelectField';
import { useAuthContext } from '../../../contexts/AuthContext';
import { RemoveCircleOutline } from '@mui/icons-material';


interface IUpdateResponsibleDialogProps extends IDefaultDialogProps {
    serviceOrder: IServiceOrder;
    handleSubmit: (event: React.FormEvent<HTMLFormElement>) => void;
}

interface IStateValues {
    responsibleId: number;
}

const UpdateResponsibleDialog: React.FC<IUpdateResponsibleDialogProps> = ({
    open,
    handleClose,
    serviceOrder,
    handleSubmit
}) => {
    const { translate } = useLanguageContext();
    const { enterprise } = useAuthContext();

    const state = useState<IStateValues>({
        responsibleId: 0
    });


    useEffect(() => {
        if (open) {
            state.update('responsibleId', +(serviceOrder.responsible?.id ?? 0));
        }
        // eslint-disable-next-line
    }, [open]);
    

    const dialogActions = useMemo(() => {
        return [
            <ActionButton action='cancel' onClick={handleClose} />,
            <ActionButton action='save' type='submit' />
        ];
        // eslint-disable-next-line
    }, [translate]);


    const departmentUsers = useMemo(() => {
        return enterprise?.departments.find(d => d.id === serviceOrder.department?.id)?.users ?? [];
    }, [enterprise?.departments, serviceOrder.department])

    
    return (
        <Dialog
            open={open}
            handleClose={handleClose}
            title={translate('editResponsible')}
            dialogActions={dialogActions}
            onSubmit={handleSubmit}
            className='dialogactions-spacebetween overflow-inherit'
            absolute={true}
            dividers={true}
        >
            <Grid container rowSpacing={DefaultConstants.gridRowSpacing}>
                <Grid item xs={12}>
                    <SelectField
                        label={translate('responsible')}
                        name='responsibleId'
                        value={state.values.responsibleId}
                        onChange={e => state.update(e.target.name, e.target.value)}
                        customData={true}
                        data={[{ id: 0, fullName: translate('undefined'), avatar: '' }].concat(departmentUsers).map(r => {
                            return <MenuItem value={+r.id} key={r.id}>
                                {
                                    r.id === 0 ? (
                                        <RemoveCircleOutline className='selectfield-default-menuitem-avatar' />
                                    ) : (
                                        <Avatar src={r.avatar} alt={r.fullName} className='selectfield-default-menuitem-avatar' />
                                    )
                                }

                                {r.fullName}
                            </MenuItem>;
                        })}
                    />
                </Grid>
            </Grid>
        </Dialog>
    );
}

export default UpdateResponsibleDialog;